// ============================================================================
// Steadfastly - EQ Score Ring Component
// Visual indicator showing Nine Questions completion score
// ============================================================================
import React from 'react';

export function EQScoreRing({ score, size = 48 }) {
  const pct = Math.min(100, (score / 8) * 100);
  const color = score >= 9 ? "#059669" : score >= 6 ? "#d97706" : "#dc2626";
  const r = 18;
  const circumference = 2 * Math.PI * r;
  const offset = circumference - (pct / 100) * circumference;
  
  return (
    <div className="relative inline-flex items-center justify-center" style={{ width: size, height: size }}>
      <svg width={size} height={size} className="transform -rotate-90">
        <circle 
          cx={size/2} 
          cy={size/2} 
          r={r} 
          fill="none" 
          stroke="#e2e8f0" 
          strokeWidth="4" 
        />
        <circle 
          cx={size/2} 
          cy={size/2} 
          r={r} 
          fill="none" 
          stroke={color} 
          strokeWidth="4" 
          strokeDasharray={circumference} 
          strokeDashoffset={offset} 
          strokeLinecap="round" 
          className="transition-all duration-500" 
        />
      </svg>
      <span className="absolute text-sm font-bold" style={{ color }}>{score}</span>
    </div>
  );
}

export default EQScoreRing;
